import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=05e1e3e2&scoped=true&"
var script = {}
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=05e1e3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e1e3e2",
  null
  
)

export default component.exports